import { render, staticRenderFns } from "./BoxLevel.vue?vue&type=template&id=73d84ce2&scoped=true"
import script from "./BoxLevel.vue?vue&type=script&lang=js"
export * from "./BoxLevel.vue?vue&type=script&lang=js"
import style0 from "./BoxLevel.vue?vue&type=style&index=0&id=73d84ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d84ce2",
  null
  
)

export default component.exports